import React, { useContext } from 'react';
import {Link} from 'react-router-dom'
import {GlobalContext} from "../../handlers/GlobalContext";

const Product = ({productId, productName, producer, strength, drugGenericName, pharmForm}) => {
    const [ state, dispatch] = useContext(GlobalContext);

    var strength_reduced = /.+?(?=\()/.exec(strength);
    strength = !!strength_reduced ? strength_reduced[0].trim() : strength;

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <div className="blog-item">
            <div className="blog-content">
                <h4 className="blog-title">
                    <Link to={`${process.env.PUBLIC_URL + '/medicinal-products/' + productId}`}>{productName}</Link>
                </h4>
                <div> {producer} </div>
                <ul className="blog-meta">
                    <li className="sub-ordinate">{drugGenericName}</li>
                    <li className="sub-ordinate">&nbsp; {strength}</li>

                    <li className="sub-ordinate">&nbsp; {pharmForm.trim()}</li>
                </ul>

                <div className="read-more">
                    <Link to={`${process.env.PUBLIC_URL + '/medicinal-products/' + productId}`}> {translate("products-info-viewDetails","VIEW DETAILS").toUpperCase()} </Link>
                </div>

            </div>

        </div>
    );
};

export default Product;